import React from 'react';
import { connect } from 'react-redux';

const getScores = (state) => {
	if (state.results && state.results.saveState && state.results.saveState.players) {
		return state.results.saveState.players
	}
}

@connect(
	state => ({
		scores: getScores(state),
		countryCode: state.user.profileData.countryCode
	})
)
export default class FinalScore extends React.PureComponent {

	personalRating (score) {
		let rating;
		if (score > 110000) {
			rating = '10';
		} else if (score > 90000) {
			rating = '9';
		} else if (score > 70000) {
			rating = '8';
		} else {
			rating = '7';
		}
		return rating
	}

	overallRating (score) {
		let rating;
		if (score > 365000) {
			rating = '10';
		} else if (score > 345000) {
			rating = '9';
		} else if (score > 330000) {
			rating = '8';
		} else {
			rating = '7';
		}
		return rating
	}

	calculateTotalScores (scores) {
		let totalScores = 0;

		for (let player in scores) {
			totalScores += scores[player].resources;
		}

		return totalScores;
	}

	render () {
		const { scores, countryCode } = this.props;
		if (!scores) return null;

		const totalDockScores = this.calculateTotalScores(scores);
		const textEN = [
			{
				"p": `You received an individual total of €${scores['player-1'].resources}.-, this means you have received a final grade: ${this.personalRating(scores['player-1'].resources)}.`,
			},
			{
				"p": `The docks as a whole has earned €${totalDockScores}.-, this means together with all the other dock owners this is a grade of: ${this.overallRating(totalDockScores)}.`,
			},
			{
				"p": "Well done, and thank you again for completing Building Docks. When you click on the 'Go to overview' button you will see the last screen and you will be redirected to the overview.",
			}
		];

		const textNL = [
			{
				"p": `Je hebt een individueel totaal van €${scores['player-1'].resources}.- verdiend, dit betekent dat je een eindcijfer ${this.personalRating(scores['player-1'].resources)} hebt behaald.`,
			},
			{
				"p": `The Docks als geheel heeft in totaal €${totalDockScores}.- verdiend, dit betekent dat je samen met de andere dok eigenaren een eindcijfer ${this.overallRating(totalDockScores)} hebt behaald.`,
			},
			{
				"p": "Goed gedaan, nogmaals bedankt voor het afronden van Building Docks. Als je op de 'Ga naar overzicht' knop klikt, kom je op het laatste scherm en word je daarna doorgeleid naar het overzicht. "
			}
		];

		const text = countryCode === 'EN' ? textEN : textNL;

		return (
			<div>
				{
					text.map((value, index) => {
						return <p key={index}>{value.p}</p>
					})
				}
			</div>
		);
	}
};
